import {useLocation} from 'react-router-dom'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {localizeCanonicalUrl} from '../utils/url'

const useCanonicalUrl = (canonicalUrl) => {
    const {pathname} = useLocation()
    const appOrigin = useAppOrigin()
    const {buildUrl, locale} = useMultiSite()

    return localizeCanonicalUrl(canonicalUrl, {
        buildUrl,
        currentOrigin: appOrigin,
        currentPath: pathname,
        localeRef: locale?.alias || locale?.id
    })
}

export default useCanonicalUrl
